/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomNameQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsSbomNameQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsSbomNameQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomNameQueryOperator>): AppSecopsSbomNameQueryOperator {
        let obj = Object.assign(new AppSecopsSbomNameQueryOperator(), model);
        AppSecopsSbomNameQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomNameQueryOperator>): AppSecopsSbomNameQueryOperator {
        if (!model) return null;
        return AppSecopsSbomNameQueryOperator.newInstance(<AppSecopsSbomNameQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomNameQueryOperator) {
        if (!obj) return;

        models.AppSecopsSbomNameQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomNameQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomNameQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * User who submitted SBOM version to include
     */
    sbom_name: Array<string>;

}
